import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import enAU from "./en-AU";
import enGB from "./en-GB";
import enUS from "./en-US";

const resources = {
  "en-AU": enAU,
  "en-GB": enGB,
  "en-US": enUS,
};

i18next.use(initReactI18next).init({
  lng: "en-AU",
  resources,
  fallbackLng: "en-AU",
  // v24+ JSON plural format (v26 migration: v3-style plurals differ; our JSON uses v4, e.g. *_other).
  compatibilityJSON: "v4",
  // Bundled in-memory resources; sync init matches v24+ initAsync (replaces removed initImmediate).
  initAsync: false,
  interpolation: {
    escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
  },
});

export default i18next;
